import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { Block, Check } from "@material-ui/icons";
import React, { useEffect, useState } from 'react';
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import axios from "../../../axios/AxiosInterceptors";
import { onError } from "../../../store/actions/popupActions";
import useStyles from "../../../Styles";

const MeterAccounts = (props) => {

    const classes = useStyles(props);
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const roles = useSelector(state => state.auth.roles);
    const [meterAccounts, setMeterAccounts] = useState([]);

    useEffect(() => {
        doSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.accountId])

    const doSearch = async () => {
        await trackPromise(axios.get("/powermeter/v1/account/" + params.accountId + "/meter").then(response => {
            if (response) {
                setMeterAccounts(response.data);
            }
        })).catch(error => {
            dispatch(onError(error));
        })
    }

    const handleOnClick = async (meterAccount) => {
        history.push("/meter-reading/account/" + params.accountId + "/meter-account/" + meterAccount.id);
    }

    return (
        <main className={classes.layout}>
            <Typography variant="h5" align="center">Generation Meter Accounts</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Button onClick={() => history.push("/meter-reading/account/" + params.accountId + "/meter-account/create")}>Create Meter Account</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
            <Table>
                <TableHead xs={{ width: "max-content" }}>
                    <TableRow>
                        <TableCell>
                            Meter Name
                        </TableCell>
                        <TableCell>Power Meter Id</TableCell>
                        <TableCell>
                            Validate Submissions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {meterAccounts && meterAccounts.length > 0 &&
                        meterAccounts.map(r => {
                            return (
                                <TableRow key={r.id + r.meterName} className={classes.tableRow} onClick={() => handleOnClick(r)}>
                                    <TableCell>{r.meterName}</TableCell>
                                    <TableCell>{r.powerMeterId}</TableCell>
                                    <TableCell>{r.validatePowerMeterSubmissions ? <Check /> : <Block />}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </main>
    )

}

export default MeterAccounts;